import { object, string } from "yup";

export const validationSchema = object().shape({
  firstName: string()
    .trim()
    .required("First name is required")
    .min(1, "First name cannot be empty"),
  lastName: string()
    .trim()
    .required("Last name is required")
    .min(1, "Last name cannot be empty"),
  email: string()
    .trim()
    .required("Email address is required")
    .email("Please enter a valid email address"),
  role: string().required("Please select a role"),
});
